



























































































































































































































































































































































































import { Component, Emit, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import DescriptionEditor from '@/components/common/DescriptionEditor.vue';
import { getModule } from 'vuex-module-decorators';
import Dialogs from '@/store/modules/Dialogs';
import Modelling from '@/store/modules/Modelling';
import ValueTypes from '@/utils/ValueTypes';
import _ from 'lodash';
import { FactorGroup } from '@/api/model/FactorResource';
import FactorResourceTypeChooser from '@/components/model-builder/FactorResourceTypeChooser.vue';
import moment from 'moment';
import Decisions from '@/store/modules/Decisions';
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import CardTitle from '@/components/common/CardTitle.vue';
import Choices from '@/store/modules/Choices';
import ListInputDialog from "@/components/forms/ListInputDialog.vue";
import * as rules from "@/rules"

const modellingModule = getModule(Modelling);
const dialogsModule = getModule(Dialogs);
const decisionsModule = getModule(Decisions);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const choicesModule = getModule(Choices);

@Component({
    components: { FactorResourceTypeChooser, DescriptionEditor, CardTitle, ListInputDialog },
})

export default class FactorResourceBuilder extends Vue {

    private readonly RULES = rules;
    private readonly SUMMARY_SCORING_FUNCTIONS = [
        {
            text: 'Weighted Sum',
            help: `For ${this.pluralFactorLabel} within this group, the score will be calculated using the average of child ${this.singularFactorLabel} scores`,
            value: 'WEIGHTED_SUM',
        },
        {
            text: 'Min',
            help: `The score for this section will be the ${this.singularFactorLabel} within the section with the lowest score`,
            value: 'MIN',
        },
        {
            text: 'Max',
            help: `The score for this section will be the ${this.singularFactorLabel} within the section with the lowest score`,
            value: 'MAX',
        },
    ];

    private DATE_TIME_FORMATS = ValueTypes.DATE_TIME_FORMATS;
    private CATEGORY_FORMATS = ValueTypes.CATEGORY_FORMATS;
    private TEXT_FORMATS = ValueTypes.TEXT_FORMATS;
    private step = 1;

    private factor: any = {};

    private dialog = false;
    private creating = false;
    private additionalParameters = false;
    private selectedType: any = null;
    private exampleDateFormat = moment().format('YYYY-MM-DD');
    private nameEmpty = true;

    get addFactorToList() {
        return workspaceOptionsModule.addFactorToList;
    }

    set addFactorToList(val: boolean) {
        workspaceOptionsModule.setAddFactorToList(val);
    }

    get factorBuilderEdit() {
        return dialogsModule.factorBuilderEdit;
    }

    get activeFactorLists(){
        return workspaceOptionsModule.activeFactorLists;
    }

    get possibleParents() {
        if (modellingModule.workingModelFactorResources) {
            return Object.values(modellingModule.workingModelFactorResources)
                .filter((f) => f.type === 'FACTOR_GROUP')
                .map((f) => f as FactorGroup)
                .filter(
                    (f) =>
                        !f.groupTypeDefinition ||
                        !f.groupTypeDefinition.type ||
                        !f.groupTypeDefinition.type.startsWith('TABLE')
                );
        }
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel;
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel;
    }

    private getTitle() {
        let title = this.isEdit ? 'Update ' + this.factor.name : `Add ${this.singularFactorLabel}`;
        if(title.length > 50){
            return title.slice(0, 47) + '...';
        }else{
            return title;
        }
    }

    private checkName() {
        if ( this.factor.name === '' ) {
            this.nameEmpty = true;
        } else {
            this.nameEmpty = false;
        }
    }

    @Watch('factorBuilderEdit')
    private onFactorBuilderEdit() {
        this.selectedType = null;
        if (this.factorBuilderEdit) {
            this.additionalParameters = false;
            if (this.isEdit && this.factorBuilderEdit.factorResourceId) {
                this.factor = _.cloneDeep(
                    modellingModule.workingModelFactorResources[
                        this.factorBuilderEdit.factorResourceId
                    ]
                );
                this.selectedType = ValueTypes.FACTOR_OPTIONS.findIndex(
                    (f) =>
                        f.type === this.factor.type &&
                        (f.valueTypeDefinition || ({} as any)).valueType ===
                            (this.factor.valueTypeDefinition || {}).valueType &&
                        (f.valueTypeDefinition || ({} as any)).valueSubType ===
                            (this.factor.valueTypeDefinition || {}).valueSubType &&
                        (f.groupTypeDefinition || ({} as any)).type ===
                            (this.factor.groupTypeDefinition || {}).type
                );

                this.step = 2;
                // fixed gear icon issue
                if (this.factor.valueTypeDefinition) {
                    this.exampleDateFormat =
                        this.factor.valueTypeDefinition.valueType === 'DATE_TIME'
                            ? moment().format(this.factor.valueTypeDefinition.format)
                            : moment().format('YYYY-MM-DD');
                    if (this.factor.valueTypeDefinition.valueType === 'TEXT') {
                        if (!this.factor.valueTypeDefinition.format) {
                            this.factor.valueTypeDefinition.format = 'PLAIN';
                        }
                    }
                }
            } else {
                this.factor = {};
                this.step = 1;
            }
            this.dialog = true;
        } else {
            this.dialog = false;
        }
    }

    get isEdit() {
        if (this.factorBuilderEdit) {
            return this.factorBuilderEdit.factorResourceId != undefined;
        }
        return false;
    }

    private selectValueType(typeDefinition: any) {
        let f: any = {
            type: typeDefinition.type,
        };
        if (typeDefinition.type === 'FACTOR_GROUP') {
            f.childrenIds = [];
            f.summaryScoringFunction = 'WEIGHTED_SUM';
            f.groupTypeDefinition = _.cloneDeep(typeDefinition.groupTypeDefinition);
            f.hideScores = false;
        } else {
            f.numWeightingDots = 1;
            f.valueTypeDefinition = _.cloneDeep(typeDefinition.valueTypeDefinition);
        }

        if (
            this.isEdit &&
            this.factor.type === 'FACTOR' &&
            f.type === 'FACTOR' &&
            this.factor.valueTypeDefinition.valueType !== f.valueTypeDefinition.valueType
            && (!['CATEGORICAL', 'TEXT'].includes(this.factor.valueTypeDefinition.valueType) || !['CATEGORICAL', 'TEXT'].includes(f.valueTypeDefinition.valueType))
        ) {
            this.factor.dataField = this.factor.id + '_' + f.valueTypeDefinition.valueType;
        }
        // Object.assign(this.factor, _.cloneDeep(f));
        // may12 - kathy
        this.factor = Object.assign({}, this.factor, f);
        // this.factor = _.cloneDeep(f);
        // Text Format default value - plain(kathy)
        if (this.factor.valueTypeDefinition) {
            if (this.factor.valueTypeDefinition.valueType === 'TEXT') {
                if (!this.factor.valueTypeDefinition.format) {
                    this.factor.valueTypeDefinition.format = 'HTML';
                }
            } else if (this.factor.valueTypeDefinition.valueType === 'CATEGORICAL') {
                if (!this.factor.valueTypeDefinition.format) {
                    this.factor.valueTypeDefinition.format = 'DROP_DOWN';
                }
            } else if (this.factor.valueTypeDefinition.valueType === 'DATE_TIME') {
                if (!this.factor.valueTypeDefinition.format) {
                    this.factor.valueTypeDefinition.format = 'YYYY-MM-DD';
                }
            }
        }
        this.step = 2;
    }

    @Emit('updated')
    private async update() {
        this.creating = true;
        await modellingModule.updateFactorResource(this.factor);
        this.creating = false;
        this.dialog = false;
    }

    @Emit()
    private async create() {
        
        if (!this.factorBuilderEdit) return;
  
        if ( this.factor.name === '' ) {
            this.nameEmpty = true;
            return;
        }
        
        this.creating = true;
        let createdFactors = await modellingModule.createFactorResource({
            parentId: this.factorBuilderEdit.parentId || 'M',
            factorResource: this.factor,
        });
        this.creating = false;
        this.dialog = false;
        return {
            factor: createdFactors ? createdFactors[0] : undefined,
            parentId: this.factorBuilderEdit.parentId,
        };
    }

    private onChangeDateFormat() {
        if (
            this.factor.valueTypeDefinition &&
            this.factor.valueTypeDefinition.valueType === 'DATE_TIME' &&
            this.factor.valueTypeDefinition.format
        ) {
            this.exampleDateFormat = moment().format(this.factor.valueTypeDefinition.format);
        }
    }

    private syncCategories() {
        let categories = choicesModule.choicesList.map(choice => {
            if(this.factor?.id in choice) {
                return choice[this.factor.id]
            }
        }).filter(val => val!=undefined && !this.factor.valueTypeDefinition.categoricalValues.includes(val))
        
        this.factor.valueTypeDefinition.categoricalValues.splice(this.factor.valueTypeDefinition.categoricalValues.length, 0, ...categories)
    }

    private categoriesEqualChoiceData(id: string) {
        let categories = choicesModule.choicesList.filter(choice => choice[id] != null && !this.factor.valueTypeDefinition.categoricalValues.includes(choice[id]))
        return categories.length === 0
    }

    private addOptionsFromList(payload: any) {
        this.factor.valueTypeDefinition.categoricalValues.splice(this.factor.valueTypeDefinition.categoricalValues.length, 0 , ...payload.names)
    }
}
